<template>
  <div class="task-list-bulk-drawers" data-testid="setup-tasklist__bulk-drawers">
    <!-- Due days drawer -->
    <lb-drawer
      :value="dueDaysDrawer"
      heading="Edit due date"
      :loading="loading"
      width="400"
      data-testid="setup-tasklist__bulk-duedays-drawer"
      @input="dueDaysDrawer = $event"
    >
      <template v-slot:body>
        <div class="task-list-bulk-drawers__duedays-body">
          <p
            class="task-list-bulk-drawers__selected-count ma-0"
            data-testid="setup-tasklist__bulk-duedays-selected-count"
          >
            {{ selectedCount }} Selected
          </p>

          <div class="task-list-bulk-drawers__duedays-field">
            <p class="task-list-bulk-drawers__duedays-label ma-0">Due Days</p>
            <lb-number
              v-model="dueDaysValue"
              label=""
              min="-200"
              :max="200"
              placeholder="Enter value between -200 and 200"
              class="task-list-bulk-drawers__duedays-input"
              data-testid="setup-tasklist__bulk-duedays-input"
            />
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer />
        <v-btn
          class="task-list-bulk-drawers__cancel-btn secondaryBtn"
          :disabled="loading"
          @click="dueDaysDrawer = false"
        >
          Cancel
        </v-btn>
        <v-btn
          class="primaryBtn"
          :loading="loading"
          data-testid="setup-tasklist__bulk-duedays-save"
          @click="confirmDueDays"
        >
          Save
        </v-btn>
      </template>
    </lb-drawer>

    <!-- Threshold drawer -->
    <lb-drawer
      :value="thresholdDrawer"
      heading="Edit Threshold"
      :loading="loading"
      width="400"
      data-testid="setup-tasklist__bulk-threshold-drawer"
      @input="thresholdDrawer = $event"
    >
      <template v-slot:body>
        <div class="task-list-bulk-drawers__threshold-body">
          <p
            class="task-list-bulk-drawers__selected-count ma-0"
            data-testid="setup-tasklist__bulk-threshold-selected-count"
          >
            {{ selectedCount }} Selected
          </p>

          <div class="task-list-bulk-drawers__threshold-row">
            <div class="task-list-bulk-drawers__threshold-copy">
              <p class="task-list-bulk-drawers__threshold-label ma-0">
                Enforce Threshold
              </p>
              <p class="task-list-bulk-drawers__threshold-desc ma-0">
                {{ locationHeader }} specific threshold applies and prevents approval until all differences
                above the limit are explained.
              </p>
            </div>
            <v-switch
              v-model="enforceThreshold"
              class="task-list-bulk-drawers__threshold-switch mt-0 pt-0"
              inset
              dense
              hide-details
              color="primary"
              data-testid="setup-tasklist__bulk-threshold-switch"
            />
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer />
        <v-btn
          class="task-list-bulk-drawers__cancel-btn secondaryBtn"
          :disabled="loading"
          @click="thresholdDrawer = false"
        >
          Cancel
        </v-btn>
        <v-btn
          class="primaryBtn"
          :loading="loading"
          data-testid="setup-tasklist__bulk-threshold-save"
          @click="confirmThreshold"
        >
          Save
        </v-btn>
      </template>
    </lb-drawer>
  </div>
</template>

<script>
import './TaskListBulkDrawers.scss';

export default {
  name: 'TaskListBulkDrawers',

  props: {
    selectedCount: {
      type: Number,
      default: 0,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dueDaysDrawer: false,
      dueDaysValue: 0,
      thresholdDrawer: false,
      enforceThreshold: true,
    };
  },

  computed: {
    locationHeader() {
      return this.$store.state.LocationHeader || 'Location';
    },
  },

  methods: {
    openDueDaysDrawer() {
      this.dueDaysValue = 0;
      this.dueDaysDrawer = true;
    },

    openThresholdDrawer() {
      this.enforceThreshold = true;
      this.thresholdDrawer = true;
    },

    confirmDueDays() {
      const raw = this.dueDaysValue;
      if (raw == null || raw === '' || (typeof raw === 'string' && !raw.trim())) {
        this.$store.commit('sbError', 'Please enter a valid due days value between -200 and 200.');
        return;
      }
      const duedays = Number(raw);
      if (!Number.isFinite(duedays)) {
        this.$store.commit('sbError', 'Please enter a valid due days value between -200 and 200.');
        return;
      }
      if (duedays < -200 || duedays > 200) {
        this.$store.commit('sbError', 'Due days must be between -200 and 200.');
        return;
      }
      this.$emit('confirm-due-days', {
        ids: this.selectedIds,
        duedays,
      });
    },

    confirmThreshold() {
      this.$emit('confirm-threshold', {
        ids: this.selectedIds,
        enforceThreshold: this.enforceThreshold,
      });
    },

    closeAfterSuccess() {
      this.dueDaysDrawer = false;
      this.thresholdDrawer = false;
    },
  },
};
</script>
